// Accessibility Cookie Storage

const AssistCookieStorage = (Cookies) => ({
    getItem(key) {
        let value = Cookies.get(key)
        if (!value) {
            return null;
        }

        if (/^\d+$/.test(value)) {
            return parseInt(value);
        }

        return JSON.stringify(value);
    },
    setItem(key, value) {

        value = JSON.parse(value);

        if (value === null) {
            Cookies.remove(key)
            return;
        }

        Cookies.set(key, value);
    }
})

// Accessibility Store

export const assistStore = (Alpine, Cookies) => {

    const storage = AssistCookieStorage(Cookies);

    return (Alpine) => Alpine.store('assist', {

        is_active: Alpine.$persist(null)
            .as('assist_active')
            .using(storage),

        is_collapsed: Alpine.$persist(null)
            .as('assist_collapsed')
            .using(storage),

        assist_font_size: Alpine.$persist(null)
            .as('assist_font_size')
            .using(storage),

        assist_font_family: Alpine.$persist(null)
            .as('assist_font_family')
            .using(storage),

        assist_color_scheme: Alpine.$persist(null)
            .as('assist_color_scheme')
            .using(storage),

        assist_images: Alpine.$persist(null)
            .as('assist_images')
            .using(storage),

        assist_line_height: Alpine.$persist(null)
            .as('assist_line_height')
            .using(storage),

        assist_letter_spacing: Alpine.$persist(null)
            .as('assist_letter_spacing')
            .using(storage),

        font_sizes: {
            sm: 'assist-font-size-sm',
            md: 'assist-font-size-md',
            lg: 'assist-font-size-lg',
        },

        font_families: {
            sans: 'assist-font-sans',
            serif: 'assist-font-serif',
        },

        color_schemes: {
            achromatic: 'assist-color-scheme-achromatic',
            invert: 'assist-color-scheme-invert',
            chromatic: 'assist-color-scheme-chromatic',
            green: 'assist-color-scheme-green',
        },

        line_heights: {
            sm: 'assist-line-height-sm',
            md: 'assist-line-height-md',
            lg: 'assist-line-height-lg',
        },

        letter_spacings: {
            sm: 'assist-letter-spacing-sm',
            md: 'assist-letter-spacing-md',
            lg: 'assist-letter-spacing-lg',
        },

        init() {
            Alpine.nextTick().then(() => {

                if (this.assist_color_scheme === null) {
                    this.assist_color_scheme = this.color_schemes.achromatic;
                }

                if (this.assist_font_family === null) {
                    this.assist_font_family = this.font_families.sans;
                }

                if (this.assist_images === null) {
                    this.assist_images = 1;
                }

                if (this.assist_line_height === null) {
                    this.assist_line_height = this.line_heights.sm;
                }

                if (this.assist_letter_spacing === null) {
                    this.assist_letter_spacing = this.letter_spacings.sm;
                }

                this.updateClassNames();
            });
        },

        updateClassNames() {

            this.setBaseClass();

            const fontSizeClass = this.is_active ? this.assist_font_size : null;
            this.setClassVariant(fontSizeClass, this.font_sizes);

            const fontFamilyClass = this.is_active ? this.assist_font_family : null;
            this.setClassVariant(fontFamilyClass, this.font_families);

            const colorSchemeClass = this.is_active ? this.assist_color_scheme : null;
            this.setClassVariant(colorSchemeClass, this.color_schemes);

            const lineHeightClass = this.is_active ? this.assist_line_height : null;
            this.setClassVariant(lineHeightClass, this.line_heights);

            const letterSpacingClass = this.is_active ? this.assist_letter_spacing : null;
            this.setClassVariant(letterSpacingClass, this.letter_spacings);

            this.setNoImagesClass();
        },

        toggleAssist() {
            this.is_active = !this.is_active ? 1 : 0;

            if (this.is_active) {
                this.is_collapsed = 0;
            }

            this.updateClassNames();
        },

        toggleAssistCollapsed() {
            this.is_collapsed = !this.is_collapsed ? 1 : 0;
        },

        setBaseClass() {

            if (this.is_active) {
                document.documentElement.classList.add('assist-active');
            } else {
                document.documentElement.classList.remove('assist-active');
            }
        },

        setFontSize(className) {

            this.assist_font_size = className;

            this.updateClassNames();
        },

        setFontFamily(className) {

            this.assist_font_family = className;

            this.updateClassNames();
        },

        toggleImagesVisibility() {
            this.assist_images = !this.assist_images ? 1 : 0;

            this.updateClassNames();
        },

        setColorScheme(className) {

            this.assist_color_scheme = className;

            this.updateClassNames();
        },

        setLineHeight(className) {
            this.assist_line_height = className;
            this.updateClassNames();
        },

        setLetterSpacing(className) {
            this.assist_letter_spacing = className;
            this.updateClassNames();
        },

        setClassVariant(className, variants) {

            Object.values(variants).forEach(classNameToRemove => {

                if (typeof classNameToRemove !== 'string') {
                    return;
                }

                document.documentElement.classList.remove(classNameToRemove);
            });

            if (className === null) {
                return;
            }

            document.documentElement.classList.add(className);
        },

        setNoImagesClass() {

            if (this.assist_images || !this.is_active) {
                document.documentElement.classList.remove('assist-no-images');
            } else {
                document.documentElement.classList.add('assist-no-images');
            }
        }

    })

};